import api          from '../../../api';
import React        from 'react';
import utils        from '../../../utils';
import values       from '../../../values';
import Context      from '../../../context';
import ParentScreen from '..';

import { TModal                 } from '../../../types/common.type';
import { useQuery               } from 'react-query';
import { DeleteModal            } from '../../../components';
import { ICreateAndUpdateParent } from '../../../types/parent.interface';

const ParentContainer: React.FC = (): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedParent, setSelectedParent] = React.useState<any>();
  const [requestParent, setRequestParent] = React.useState<any>({
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    page: 1,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultParent = useQuery(
    [
      values.useQueryKeys.getAllParent,
      requestParent?.page,
      requestParent?.search?.value,
      requestParent?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.administrator.getAllParent({
        filters     : requestParent?.filters,
        search      : requestParent?.search ,
        limit       : requestParent?.limit  ,
        page        : requestParent?.page   ,
        academicYear: selectedYear?._id     ,
      })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(formData: ICreateAndUpdateParent) {
    setIsLoading(true);
    const result = await api.post.common.createParent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      await resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunction(formData: ICreateAndUpdateParent) {
    setIsLoading(true);
    const result = await api.put.common.updateParent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      await resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    setIsLoading(true);
    const result = await api.dele.common.deleteParent(userId);
    if (result) {
      utils.successHandler(Number(result.CODE));
      await resultParent.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.ParentScreen.Provider
      value={{
        refetch: resultParent.refetch,
        showModal     ,
        isLoading     ,
        requestParent ,
        selectedParent,
        setShowModal     ,
        setIsLoading     ,
        createFunction   ,
        updateFunction   ,
        deleteFunction   ,
        setRequestParent ,
        setSelectedParent,
      }}
    >
      <ParentScreen resultParent={resultParent} />
      <DeleteModal
        user     = { selectedParent }
        open     = { showModal === 'DELETE' }
        loading  = { isLoading }
        onClose  = { () => setShowModal('NONE') }
        onSubmit = { deleteFunction }
      />
    </Context.ParentScreen.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default ParentContainer;
